import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/tenant/applications/application/root'

export const generalRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/general',
    component: lazyRouteComponent(() => import('./General'), 'General'),
    loader: ({ parentMatchPromise }) => parentMatchPromise,
})
